import React, { useState } from "react";

import HeatMap from "../../heatmaptest/src";

import {
  getColor,
  formatedNumbers,
  getFormatedNumber,
  dataSet1,
  daysOfWeek,
  times,
  heatmapColors
} from "./dev.getdata";

import styled from "styled-components";
import CV from "../../styles/variables";
import MQ from "../../styles/mediaQueries";

import "./heatmap.css";

// //apollo imports
// import { GET_HEATMAP_DATA } from "../../apollo/queries/heatmap";
// import { Query, QueryResult } from "react-apollo";

//components
import Tooltip from "../../components/tooltip";

//models
import { TooltipObj } from "../../models/tooltip";

//helpers
import { getRelativePosition } from "./helpers";

const HeatMapAny = HeatMap as any;

const Heatmap: React.FunctionComponent = () => {
  const [data, setStateData] = useState(dataSet1);

  return (
    <Container>
      <div>
        <Title> Day/Hour Heatmap</Title>
      </div>
      <div>
        <HeatMapAny
          xLabels={times}
          yLabels={daysOfWeek}
          data={data}
          cellStyle={(
            background: string,
            value: number,
            min: number,
            max: number,
            data: any,
            x: number,
            y: number
          ) => ({
            background: `${getColor(value)}`
          })}
          numberViews={(value: any) => getFormatedNumber(value)}
          hoverStyles={{
            display: "none",
            position: "absolute",
            top: "-62px",
            left: "-24px",
            width: "124px",
            height: "50px",
            opacity: "0.88",
            borderRadius: "4px",
            backgroundColor: "#1b57cc",
            marginLeft: "8px",
            color: "white"
          }}
          legendColors={heatmapColors}
          legendLabels={formatedNumbers}
        />
      </div>
    </Container>
  );
};

const Container = styled.div`
  background-color: white;
  width: 100%;
  padding: 20px;
  box-shadow: 0 4px 20px 0 rgba(15, 40, 131, 0.08);
  padding-bottom: 40px;
  min-width: 600px;
  ${MQ.tablet} {
    padding: 40px;
  }
`;

const Title = styled.h2`
  text-align: center;
  font-size: 16px;
  margin-bottom: 16px;
  ${MQ.tablet} {
    font-size: 20px;
    margin-bottom: 32px;
  }
`;

export default Heatmap;
